import config from '../config';

/**
 * Helpers for Buildings and Environment Checks
 */

// eslint-disable-next-line
export enum Environments {
  INT = 'int',
  QA = 'qa',
  LOCAL = 'local',
  PROD = 'prod',
  STAGE = 'stage',
}

export const isTestingEnvironment = () => [Environments.INT, 'integration', Environments.QA, Environments.LOCAL].includes(config.appEnv);

export const isLocalEnvironment = () => config.appEnv === Environments.LOCAL;
